if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityCompact = this.querySelector('pickup-availability-compact');
			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompact = this.querySelector('[data-js-product-price-compact');
			this.priceExtended = this.querySelector('[data-js-product-price-extended');

			if ( this.priceCompact ) {
				this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
				this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
				this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
			}
			if ( this.priceExtended ) {
				this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
				this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
				this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
			}

			this.initMetafieldVariantGroupPrefetch();
			this.initMetafieldVariantGroupHorizontalMorrison();

			this._inventoryNoticeMinWidthRaf = null;
			this._syncInventoryNoticeTextMinWidth = this._syncInventoryNoticeTextMinWidth.bind(this);
			this._scheduleSyncInventoryNoticeTextMinWidth = this._scheduleSyncInventoryNoticeTextMinWidth.bind(this);
			this._scheduleSyncInventoryNoticeTextMinWidth();
			window.addEventListener('resize', this._scheduleSyncInventoryNoticeTextMinWidth);
			setTimeout(() => this._scheduleSyncInventoryNoticeTextMinWidth(), 100);
			setTimeout(() => this._scheduleSyncInventoryNoticeTextMinWidth(), 600);

		}

		_scheduleSyncInventoryNoticeTextMinWidth() {

			if ( !this.querySelector('.product-inventory-notice--align-right') ) {
				return;
			}
			if ( this._inventoryNoticeMinWidthRaf ) {
				cancelAnimationFrame(this._inventoryNoticeMinWidthRaf);
			}
			this._inventoryNoticeMinWidthRaf = requestAnimationFrame(() => {
				this._inventoryNoticeMinWidthRaf = null;
				this._syncInventoryNoticeTextMinWidth();
			});

		}

		_syncInventoryNoticeTextMinWidth() {

			if ( !this.querySelector('.product-inventory-notice--align-right') ) {
				this.classList.remove('has-inv-notice-btn-width');
				this.style.removeProperty('--product-inv-notice-text-min-width');
				return;
			}

			/* Alinhamento com o CTA só em desktop — min-width do botão estoura a coluna no mobile */
			if ( window.matchMedia('(max-width: 767px)').matches ) {
				this.classList.remove('has-inv-notice-btn-width');
				this.style.removeProperty('--product-inv-notice-text-min-width');
				return;
			}

			const btn = this.querySelector('[data-js-product-add-to-cart]');
			const notice = this.querySelector('.product-inventory-notice--align-right');
			const btnW = btn ? Math.round(btn.getBoundingClientRect().width) : 0;
			const maxW = notice
				? Math.round(notice.getBoundingClientRect().width)
				: 0;
			const w = maxW > 0 ? Math.min(btnW, maxW) : btnW;

			if ( w > 0 ) {
				this.style.setProperty('--product-inv-notice-text-min-width', `${w}px`);
				this.classList.add('has-inv-notice-btn-width');
			} else {
				this.classList.remove('has-inv-notice-btn-width');
				this.style.removeProperty('--product-inv-notice-text-min-width');
			}

		}

		initMetafieldVariantGroupPrefetch(){

			const root = this.querySelector('[data-js-metafield-variant-group]');
			if ( !root ) {
				return;
			}

			const dataEl = root.querySelector('[data-metafield-group-prefetch-urls]');
			if ( !dataEl ) {
				return;
			}

			let urls = [];
			try {
				urls = JSON.parse(dataEl.textContent);
			} catch (e) {
				return;
			}

			if ( !Array.isArray(urls) || urls.length === 0 ) {
				return;
			}

			const here = window.location.href.split('#')[0];

			urls = urls.map((u) => String(u).split('#')[0]).filter((u) => u && u !== here);
			if ( urls.length === 0 ) {
				return;
			}

			const linkKeys = new Set();
			const appendPrefetchLinks = () => {
				urls.forEach((url) => {
					const key = String(url).split('#')[0];
					if ( !key || key === here || linkKeys.has(key) ) {
						return;
					}
					linkKeys.add(key);
					const link = document.createElement('link');
					link.rel = 'prefetch';
					link.setAttribute('href', key);
					document.head.appendChild(link);
				});
			};

			const supportsSpeculationRules = typeof HTMLScriptElement !== 'undefined' && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');

			let usedListSpeculation = false;
			if ( supportsSpeculationRules ) {
				try {
					const s = document.createElement('script');
					s.type = 'speculationrules';
					s.textContent = JSON.stringify({
						prefetch: [{ source: 'list', urls }]
					});
					document.body.appendChild(s);
					usedListSpeculation = true;
				} catch (e) {
					usedListSpeculation = false;
				}
			}

			if ( !usedListSpeculation ) {
				appendPrefetchLinks();
			}

			root.querySelectorAll('a[data-metafield-group-product-url]').forEach((anchor) => {
				const boost = () => {
					const url = anchor.getAttribute('data-metafield-group-product-url') || anchor.href;
					const key = String(url || '').split('#')[0];
					if ( !key || key === here || linkKeys.has(key) ) {
						return;
					}
					linkKeys.add(key);
					const link = document.createElement('link');
					link.rel = 'prefetch';
					link.setAttribute('href', key);
					document.head.appendChild(link);
				};
				anchor.addEventListener('pointerenter', boost, { passive: true });
				anchor.addEventListener('focusin', boost);
			});

			const idle = window.requestIdleCallback || function (cb) { return setTimeout(function () { cb({ didTimeout: true, timeRemaining: function () { return 0; } }); }, 1600); };

			idle(function () {
				root.querySelectorAll('.product-metafield-variant-group__figure img[src]').forEach((img) => {
					if ( img.dataset.prefetchDecoded === 'true' ) {
						return;
					}
					img.dataset.prefetchDecoded = 'true';
					const im = new Image();
					im.src = img.currentSrc || img.src;
				});
			});

		}

		/**
		 * Desliz horizontal (Morrison): rAF + pointer-events:none en <a> al arrastrar.
		 * Híbrido en <a class="...__thumb">: sin preventDefault/capture en pointerdown para no matar el click;
		 * tras >5px de movimiento: capture (ratón), disableLinks y scroll como el resto del strip.
		 */
		initMetafieldVariantGroupHorizontalMorrison(){

			const root = this.querySelector('[data-js-metafield-variant-group]');
			if ( !root ) {
				return;
			}
			const list = root.querySelector('[data-js-metafield-variant-horizontal]');
			if ( !list || list.dataset.mfvgMorrisonInit === '1' ) {
				return;
			}
			list.dataset.mfvgMorrisonInit = '1';

			const links = list.querySelectorAll('a.product-metafield-variant-group__thumb');
			const disableLinks = ()=>{
				links.forEach(( link )=>{
					link.style.pointerEvents = 'none';
				});
			};
			const enableLinks = ()=>{
				links.forEach(( link )=>{
					link.style.pointerEvents = '';
				});
			};

			/* Centrar miniatura actual solo en el carril horizontal.
			   scrollIntoView() en iOS/Android también mueve el scroll de la página (~20px). */
			const centerCurrentThumbInList = ()=>{
				const currentThumb = list.querySelector('.product-metafield-variant-group__thumb--current');
				if ( !currentThumb || list.scrollWidth <= list.clientWidth + 1 ) {
					return;
				}
				const item = currentThumb.closest('.product-metafield-variant-group__item');
				if ( !item ) {
					return;
				}
				const pageScrollY = window.scrollY;
				const target = item.offsetLeft - ( list.clientWidth - item.offsetWidth ) / 2;
				list.scrollLeft = Math.max( 0, Math.min( target, list.scrollWidth - list.clientWidth ) );
				if ( window.scrollY !== pageScrollY ) {
					window.scrollTo( 0, pageScrollY );
				}
			};
			requestAnimationFrame(()=>{
				requestAnimationFrame(centerCurrentThumbInList);
			});

			let isDown = false;
			let startClientX = 0;
			let scrollLeft0 = 0;
			let hasMoved = false;
			let animationId = null;
			let activePointerId = null;
			let dragStartedOnThumbLink = false;

			const canScrollX = ()=>{
				return list.scrollWidth > list.clientWidth + 1;
			};

			list.addEventListener('pointerdown', ( e )=>{
				if ( e.pointerType === 'mouse' && e.button !== 0 ) {
					return;
				}
				dragStartedOnThumbLink = !!e.target.closest('a.product-metafield-variant-group__thumb');
				isDown = true;
				hasMoved = false;
				activePointerId = e.pointerId;
				list.classList.add('is-mfvg-active');
				startClientX = e.clientX;
				scrollLeft0 = list.scrollLeft;
				/* Desde miniatura enlace: no preventDefault ni capture aquí → el click en desktop/touch sigue vivo.
				   Desde hueco/ul: captura + preventDefault en ratón como antes. */
				if ( !dragStartedOnThumbLink && e.pointerType !== 'touch' ) {
					try {
						list.setPointerCapture(e.pointerId);
					} catch (err) {
						// ignore
					}
				}
				if ( !dragStartedOnThumbLink && e.pointerType !== 'touch' ) {
					e.preventDefault();
				}
			}, { passive: false });

			list.addEventListener('pointermove', ( e )=>{
				if ( !isDown || e.pointerId !== activePointerId ) {
					return;
				}
				const walk = ( e.clientX - startClientX ) * 1.5;
				if ( Math.abs(walk) > 5 ) {
					if ( !hasMoved ) {
						hasMoved = true;
						disableLinks();
						if ( dragStartedOnThumbLink && e.pointerType !== 'touch' ) {
							try {
								list.setPointerCapture(e.pointerId);
							} catch (err) {
								// ignore
							}
						}
					}
				}
				if ( hasMoved && canScrollX() ) {
					e.preventDefault();
				}
				if ( animationId ) {
					cancelAnimationFrame(animationId);
				}
				animationId = window.requestAnimationFrame(()=>{
					list.scrollLeft = scrollLeft0 - walk;
				});
			}, { passive: false });

			const endDrag = ( e, opts )=>{
				const fromLeave = opts && opts.fromLeave;
				if ( !isDown ) {
					return;
				}
				if ( e && e.pointerId !== activePointerId ) {
					return;
				}
				const pid = activePointerId;
				isDown = false;
				activePointerId = null;
				dragStartedOnThumbLink = false;
				list.classList.remove('is-mfvg-active');
				enableLinks();
				if ( animationId ) {
					cancelAnimationFrame(animationId);
					animationId = null;
				}
				try {
					if ( e && list.releasePointerCapture && pid != null && list.hasPointerCapture && list.hasPointerCapture(pid) ) {
						list.releasePointerCapture(pid);
					}
				} catch (err) {
					// ignore
				}
				if ( hasMoved && e && !fromLeave ) {
					e.preventDefault();
					e.stopPropagation();
				}
			};

			list.addEventListener('pointerup', endDrag);
			list.addEventListener('pointercancel', endDrag);

			/* pointerleave con touch a veces dispara al cruzar hijos (img) y corta el gesto */
			list.addEventListener('pointerleave', ( e )=>{
				if ( e.pointerType === 'touch' ) {
					return;
				}
				if ( !isDown || e.pointerId !== activePointerId ) {
					return;
				}
				endDrag(e, { fromLeave: true });
			});

			list.addEventListener('click', ( e )=>{
				if ( !hasMoved ) {
					return;
				}
				e.preventDefault();
				e.stopPropagation();
				hasMoved = false;
			}, true);

			/* Si el dedo suelta fuera del strip, pointerup puede ir al document */
			const docEnd = ( e )=>{
				if ( !isDown || e.pointerId !== activePointerId ) {
					return;
				}
				endDrag(e);
			};
			document.addEventListener('pointerup', docEnd, { capture: true });
			document.addEventListener('pointercancel', docEnd, { capture: true });
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'block';
					this.querySelector('pickup-availability-compact').fetchAvailability(variant.id);
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'block';
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

			} else {

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'none';
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'none';
				}

			}

			// update prices (overwrites the framework)

			if ( this.priceCompact ) {
				if ( !variant ) {
					this.priceCompact.priceOriginal.innerHTML = '';
					this.priceCompact.priceCompare.innerHTML = '';
					this.priceCompact.priceUnit.innerHTML = '';
				} else {
					this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price ) {
						this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
						//this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
					} else {
						this.priceCompact.priceCompare.innerHTML = '';
					}

					if ( variant.unit_price_measurement ) {
						this.priceCompact.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceCompact.priceUnit.innerHTML = '';
					}
				}
			}

			if ( this.priceExtended ) {
				if ( !variant ) {
					this.priceExtended.priceOriginal.innerHTML = '';
					this.priceExtended.priceCompare.innerHTML = '';
					this.priceExtended.priceUnit.innerHTML = '';
				} else {
					this.priceExtended.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price ) {
						this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(variant.compare_at_price - variant.price, KROWN.settings.shop_money_format))}</span>`;
					} else {
						this.priceExtended.priceCompare.innerHTML = '';
					}

					if ( variant.unit_price_measurement ) {
						this.priceExtended.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceExtended.priceUnit.innerHTML = '';
					}
				}
			}

			this.updateInventoryStockNotices(variant);

			this._scheduleSyncInventoryNoticeTextMinWidth();

		}

		updateInventoryStockNotices(variant) {

			this.querySelectorAll('[data-js-product-inventory-notice]').forEach((root) => {
				const label = root.querySelector('[data-js-product-inventory-notice-label]');
				if (!label) {
					return;
				}

				let invMap = null;
				const mapAttr = root.getAttribute('data-inventory-by-variant');
				if ( mapAttr ) {
					try {
						invMap = JSON.parse(mapAttr.trim());
					} catch (e) {
						invMap = null;
					}
				}

				const threshold = parseInt(root.dataset.threshold, 10);
				const thr = Number.isNaN(threshold) ? 10 : threshold;
				const rawBL = root.getAttribute('data-text-before-low') ?? '';
				const rawAL = root.getAttribute('data-text-after-low') ?? '';
				const fbExact = window.KROWN?.settings?.locales?.products_inventory_notice_exact || '';
				const fbLow = window.KROWN?.settings?.locales?.products_inventory_notice_low || '';

				if (!variant) {
					root.hidden = true;
					label.textContent = '';
					return;
				}

				const qty = this._inventoryNoticeQty(variant, invMap);
				const visible = qty > 0 && (thr === 0 || qty < thr);

				if (!visible) {
					root.hidden = true;
					label.textContent = '';
					return;
				}

				if (thr === 0) {
					label.textContent = (fbExact || '').split('{{ count }}').join(String(qty));
				} else if (!rawBL.trim() && !rawAL.trim()) {
					label.textContent = (fbLow || '').split('{{ count }}').join(String(qty));
				} else {
					label.textContent = this._formatInventoryNoticeLine(rawBL, qty, rawAL);
				}
				root.hidden = false;
			});

		}

		_formatInventoryNoticeLine(rawBefore, qty, rawAfter) {

			const b = (rawBefore ?? '').trim();
			const a = (rawAfter ?? '').trim();
			const q = String(qty);
			const parts = [];
			if ( b ) {
				parts.push(b);
			}
			parts.push(q);
			if ( a ) {
				parts.push(a);
			}
			return parts.join(' ');

		}

		_inventoryNoticeQty(variant, invMap) {

			const raw = variant.inventory_quantity;
			if ( typeof raw === 'number' && !Number.isNaN(raw) ) {
				return raw;
			}
			if ( raw != null && raw !== '' ) {
				const parsed = parseInt(String(raw), 10);
				if ( !Number.isNaN(parsed) ) {
					return parsed;
				}
			}
			if ( invMap && Array.isArray(invMap) ) {
				const row = invMap.find((r) => String(r.id) === String(variant.id));
				if ( row && row.q != null ) {
					const pq = parseInt(String(row.q), 10);
					if ( !Number.isNaN(pq) ) {
						return pq;
					}
				}
			}
			return 0;

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}